import { DocumentUploadComponent } from './document-upload/document-upload.component';
export var documentRoutes = [
    {
        path: 'document',
        children: [
            {
                path: 'upload',
                component: DocumentUploadComponent
            }
        ],
    },
];
var DocumentRoutingModule = (function () {
    function DocumentRoutingModule() {
    }
    return DocumentRoutingModule;
}());
export { DocumentRoutingModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/document/document-routing.module.ts.pre-build-optimizer.js